module.exports = __webpack_public_path__ + "static/media/item_2_7.08665d29.png";